export const PAGE_HEADER_HEIGHT = '7.6rem';
export const EDITOR_HEADER_HEIGHT = '5.4rem';
